import { React, useContext, useState } from "react";

import ThemeContext from "../../lib/theme-context";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import ListSubheader from "@mui/material/ListSubheader";

const CustomSelect = ({
  size,
  inputLabel,
  value,
  label,
  onChange,
  menuItemArray,
  color,
}) => {
  const theme = useContext(ThemeContext);
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <FormControl fullWidth size={size}>
      <InputLabel
        sx={{
          color:
            theme[0] === "dark"
              ? "#FCFCFF !important"
              : "rgba(37,37,37) !important",
          borderOutline:
            theme[0] === "dark"
              ? "#FCFCFF !important"
              : "rgba(37,37,37) !important",
        }}
      >
        {inputLabel}
      </InputLabel>

      <Select
        MenuProps={{
          PaperProps: {
            sx: {
              bgcolor: theme[0] === "dark" ? "rgba(40, 42, 46)" : "#FCFCFF",
              maxHeight: "450px",

              "& .MuiMenuItem-root": {
                padding: 1.5,
                justifyContent: "center",
              },
            },
          },
        }}
        defaultValue=""
        fullWidth
        open={menuOpen}
        onOpen={() => setMenuOpen(true)}
        onClose={() => {
          setTimeout(() => setMenuOpen(false), 200);
        }}
        sx={{
          backgroundColor: theme[0] === "dark" ? "#3a3d45" : "#e5e7eb",
          color: theme[0] === "dark" ? "#FCFCFF" : "#1f2937",
          borderRadius: menuOpen ? "12px 12px 0 0" : "12px",
          fontSize: "14px",
          fontWeight: 600,
          transition: "border-radius 0.2s ease-in-out",
          ".MuiSvgIcon-root": {
            fill: theme[0] === "dark" ? "#FCFCFF" : "#1f2937",
          },
          "& fieldset": {
            border: "none",
          },
          "&:hover": {
            backgroundColor: theme[0] === "dark" ? "#434650" : "#d1d5db",
          },
          "&:hover fieldset": {
            border: "none",
          },
          "&.Mui-focused": {
            backgroundColor: theme[0] === "dark" ? "#3a3d45" : "#e5e7eb",
          },
          "&.Mui-focused fieldset": {
            border: "none",
          },
          "& .MuiSelect-select": {
            paddingTop: "8px",
            paddingBottom: "8px",
            paddingLeft: "12px",
            paddingRight: "12px",
          },
        }}
        value={value}
        label={label}
        onChange={onChange}
        displayEmpty
        renderValue={(selected) => {
          if (!selected || selected === "") {
            return (
              <span style={{ 
                color: theme[0] === "dark" ? "#9ca3af" : "#6b7280",
                fontWeight: 600
              }}>
                {inputLabel || ""}
              </span>
            );
          }
          const parsedItems = JSON.parse(menuItemArray || "[]");
          const selectedItem = parsedItems.find(item => item.value === selected);
          return selectedItem ? selectedItem.value : selected;
        }}
      >
        {JSON.parse(menuItemArray).map((item, index) => {
          if (item.isGroup) {
            return (
              <ListSubheader
                key={item.label + index}
                sx={{
                  color: item.color || (theme[0] === "dark" ? "#9ca3af" : "#6b7280"),
                  fontWeight: 600,
                  fontSize: "13px",
                  backgroundColor: theme[0] === "dark" ? "rgba(40, 42, 46)" : "#FCFCFF",
                  textAlign: "center",
                }}
              >
                {item.label}
              </ListSubheader>
            );
          }
          return (
            <MenuItem
              key={item.value + index}
              sx={{
                color: theme[0] === "dark" ? "#FCFCFF" : "rgba(40, 42, 46)",
              }}
              value={item.value}
            >
              {item.label}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default CustomSelect;
